export default __webpack_public_path__ + "static/media/paladin-icon.2de36f6b.ico";